import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesAceptCreditConditionsModule} from "./accept-credit-conditions/sales-acept-credit-conditions.module";
import {SalesAdditionalInformationModule} from "./additional-information/sales-additional-information.module";
import {SalesCategoryModule} from "./category/sales-category.module";
import {SalesGeneralProductModule} from "./product/sales-general-product.module";
import {SalesStoreModule} from "./store/sales-store.module";
import {SalesClientIdentificationModule} from "./client-identification/sales-client-identification.module";
import {SalesCreditBureauModule} from "./credit-bureau/sales-credit-bureau.module";
import {SalesCreditSummaryModule} from "./credit-summary/sales-credit-summary.module";
import {SalesFinalInstructionsClientModule} from "./final-instructions-client/sales-final-instructions-client.module";
import {SalesReviewContractModule} from "./review-contract/sales-review-contract.module";
import {SalesFinalMessageModule} from "./final-message/sales-final-message.module";
import {SalesPhoneAppInstalationModule} from "./phone-app-instalation/sales-phone-app-instalation.module";
import {SalesPhoneEnrollmentModule} from "./phone-enrollment/sales-phone-enrollment.module";
import {SalesPhoneRegisterModule} from "./phone-register/sales-phone-register.module";
import {SalesGeneralCreditSummaryModule} from "./sales-general-credit-summary/sales-general-credit-summary.module";
import {SalesSelfManagementModule} from "./self-management/sales-self-management.module";
import {SalesTakePictureModule} from "./take-picture/sales-take-picture.module";
import {SalesIdentityDocumentPhotoModule} from "./identity-document-photo/sales-identity-document-photo.module";
import {SalesUpdateClientInformationModule} from "./update-client-information/sales-update-client-information.module";
import {
  SalesUpdateProductInformationModule
} from "./update-product-information/sales-update-product-information.module";
import {SalesValidateGeolocalizationModule} from "./validate-geolocalization/sales-validate-geolocalization.module";
import {SalesClientVerificationModule} from "./client-verification/sales-client-verification.module";
import {SalesErrorMessageModule} from "./error-message/sales-error-message.module";
import {SalesCreditSetupModule} from "./credit-setup/sales-credit-setup.module";
import {SalesPaymentInformationModule} from "./payment-information/sales-payment-information.module";
import {SalesPreClientVerificationModule} from "./pre-client-verification/sales-pre-client-verification.module";
import {SalesQuotasModule} from "./quotas/sales-quotas.module";
import {SalesSigningContractModule} from "./signing-contract/sales-signing-contract.module";
import {SalesAdvancedContractSigningModule} from "./advanced-contract-signing/sales-advanced-contract-signing.module";
import {SalesSimulatorModule} from "./simulator/sales-simulator.module";
import {SalesPointSaleModule} from "./point-sale/sales-point-sale.module";
import {
  SalesClientIdentificationExpressKredicashModule
} from "./client-identification-express/sales-client-identification-express-kredicash.module";
import {SalesCreateRequestModule} from "./create-request/sales-create-request.module";
import {SalesSelectConditionsModule} from "./select-conditions/sales-select-conditions.module";
import {SalesSearchRequestModule} from "./search-request/sales-search-request.module";
import {SalesRegisteredApplicationModule} from "./registered-application/sales-registered-application.module";
import {SalesRequestCreditBureauModule} from "./request-credit-bureau/sales-request-credit-bureau.module";
import {SalesVerificationCodeModule} from "./verification-code/sales-verification-code.module";
import {SalesStoreListModule} from "./store-list/sales-store-list.module";

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SalesAceptCreditConditionsModule,
    SalesAdditionalInformationModule,
    SalesCategoryModule,
    SalesGeneralProductModule,
    SalesClientIdentificationModule,
    SalesCreditBureauModule,
    SalesFinalInstructionsClientModule,
    SalesCreditSummaryModule,
    SalesReviewContractModule,
    SalesFinalMessageModule,
    SalesPhoneAppInstalationModule,
    SalesPhoneEnrollmentModule,
    SalesPhoneRegisterModule,
    SalesGeneralCreditSummaryModule,
    SalesSelfManagementModule,
    SalesTakePictureModule,
    SalesIdentityDocumentPhotoModule,
    SalesUpdateClientInformationModule,
    SalesUpdateProductInformationModule,
    SalesValidateGeolocalizationModule,
    SalesClientVerificationModule,
    SalesErrorMessageModule,
    SalesCreditSetupModule,
    SalesPaymentInformationModule,
    SalesPreClientVerificationModule,
    SalesQuotasModule,
    SalesSigningContractModule,
    SalesAdvancedContractSigningModule,
    SalesSimulatorModule,
    SalesPointSaleModule,
    SalesClientIdentificationExpressKredicashModule,
    SalesCreateRequestModule,
    SalesSelectConditionsModule,
    SalesSearchRequestModule,
    SalesRegisteredApplicationModule,
    SalesCreateRequestModule,
    SalesRequestCreditBureauModule,
    SalesVerificationCodeModule,
    SalesStoreListModule
  ],
  exports: [
    SalesAceptCreditConditionsModule,
    SalesAdditionalInformationModule,
    SalesCategoryModule,
    SalesGeneralProductModule,
    SalesStoreModule,
    SalesClientIdentificationModule,
    SalesCreditBureauModule,
    SalesFinalInstructionsClientModule,
    SalesCreditSummaryModule,
    SalesReviewContractModule,
    SalesFinalMessageModule,
    SalesPhoneAppInstalationModule,
    SalesPhoneEnrollmentModule,
    SalesPhoneRegisterModule,
    SalesGeneralCreditSummaryModule,
    SalesSelfManagementModule,
    SalesTakePictureModule,
    SalesIdentityDocumentPhotoModule,
    SalesUpdateClientInformationModule,
    SalesUpdateProductInformationModule,
    SalesValidateGeolocalizationModule,
    SalesClientVerificationModule,
    SalesErrorMessageModule,
    SalesCreditSetupModule,
    SalesPaymentInformationModule,
    SalesPreClientVerificationModule,
    SalesQuotasModule,
    SalesSigningContractModule,
    SalesAdvancedContractSigningModule,
    SalesSimulatorModule,
    SalesPointSaleModule,
    SalesClientIdentificationExpressKredicashModule,
    SalesCreateRequestModule,
    SalesSelectConditionsModule,
    SalesSearchRequestModule,
    SalesRegisteredApplicationModule,
    SalesCreateRequestModule,
    SalesRequestCreditBureauModule,
    SalesVerificationCodeModule,
    SalesStoreListModule
  ]
})
export class SalesModule { }
